<!-- <template>
  <div class="show-report">
    <van-sticky>
      <van-nav-bar title="查看报告" left-arrow @click-left="goBack" />
    </van-sticky>
    <div>
      <pdf v-for="i in numPages" @progress="loadedRatio = $event" :key="i" :src="src" :page="i"></pdf>
    </div>
  </div>
</template>

<script>
// 移除meta
import pdf from "vue-pdf";
import { Toast } from "vant";
export default {
  components: {
    pdf
  },
  data() {
    return {
      scale: 100,
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      src: '', // pdf路径
      numPages: 0,
      url: this.$route.query.url,
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      isShow: false
    };
  },
  mounted() {
    var url = this.$route.query.url // 文件地址
    this.src = pdf.createLoadingTask(url)
    this.src.promise.then((pdf) => {
      this.numPages = pdf.numPages
      Toast.clear()
    })
  },
  created() {
    Toast.loading({
      duration: 0,
      message: "加载中...",
      forbidClick: true
    })
    document.getElementById("viewport").setAttribute('content','user-scalable=yes, width=device-width, minimum-scale=1, initial-scale=1, maximum-scale=2')
  },
  methods: {
    prePage() {
      let page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    goBack() {
      // 去我的
      // this.$router.push({
      //   path: '/testing-record'
      // })
      this.$router.go(-1);
    },
    getNumber(num) {
      console.log("num-----");
      console.log(num);
      if (num) {
        this.isShow = true;
        Toast.clear();
      }
    }
  }
};
</script>

<style scoped lang="less">
.show-report {
  // width: 100%;
  // height: 100%;
  .line {
    height: 20px;
  }
}
</style> -->


<template>
  <div class="show-report">
    <van-sticky>
      <van-nav-bar title="查看报告" left-arrow @click-left="goBack" />
    </van-sticky>
    <div>
      <!-- <pdf
        :page="pageNum"
        :src="url"
        @progress="loadedRatio = $event"
        @num-pages="pageTotalNum = $event"
        @page-loaded="getNumber"
      ></pdf>
      <div class="line"></div>
      <van-pagination
        v-model="pageNum"
        :page-count="pageTotalNum"
        mode="simple"
        v-if="isShow"
      /> -->
      <!-- <pdf v-for="i in numPages" @progress="loadedRatio = $event" :key="i" :src="src" :page="i"></pdf> -->
    <!-- pdf-vue to iframe -->
      <iframe style="width: 100%;height: 100vh; border: 0;" :src="src"></iframe>
    </div>
  </div>
</template>

<script>
// 移除meta
import pdf from "vue-pdf";
import { Toast } from "vant";
export default {
  components: {
    pdf
  },
  data() {
    return {
      scale: 100,
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      src: '', // pdf路径
      numPages: 0,
      url: this.$route.query.url,
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      isShow: false
    };
  },
  mounted() {
    var url = this.$route.query.url // 文件地址
    this.src = url
    //this.src = pdf.createLoadingTask(url)
    // this.src.promise.then((pdf) => {
    //   this.numPages = pdf.numPages
    //   Toast.clear()
    // })
  },
  // created() {
  //   Toast.loading({
  //     duration: 0,
  //     message: "加载中...",
  //     forbidClick: true
  //   })
  //   document.getElementById("viewport").setAttribute('content','user-scalable=yes, width=device-width, minimum-scale=1, initial-scale=1, maximum-scale=2')
  // },
  methods: {
    prePage() {
      let page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    goBack() {
      this.$router.go(-1);
    },
    getNumber(num) {
      console.log("num-----");
      console.log(num);
      if (num) {
        this.isShow = true;
        Toast.clear();
      }
    }
  }
};
</script>

<style scoped lang="less">
.show-report {
  // width: 100%;
  // height: 100%;
  background: #e5e5e5;
  .line {
    height: 20px;
  }
}
</style>
